import { Expose, Type, Transform } from 'class-transformer';
import { BasicData } from '../basic/BasicData';

export class User {

    static readonly  ModelFeatureAttribute = {
        CLASS_NAME: 'Users'
    }

    @Expose()
    id: number;

    @Expose()
    email: string = '';

    @Expose()
    roles: Array<{ type: string; label: string }> = [];

    @Expose()
    enabled: boolean = true;

}
